import { URL_BASE, URL_BASE_PAGOS2, URL_BASE_ORDENESPAGO, URL_BASE_PROVEEDORES, URL_BASE_ORDENESPAGO_BUSCAR, URL_GET_OP_XLS } from "../../constants/url";
import {
  composeErrorNotification,
  composeSuccessNotification,
} from "../../utils/composeNotification";
import { get, post, getFile, dele, postFile, postGetFile } from "../../utils/fetch";
import { notification } from "./notificationActions";
import { types } from "../types/types";

/**
 * enviar OP por Email - Solicitar factura al proveedor
 * POST /api/Pagos2/EnviarOpPorEmail
 * body: { emails: "email1,email2", ordenPagoID: number }
 */
export const startEnviarOpPorEmail = (ordenPagoID, emails) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/EnviarOpPorEmail`;
    const result = await post(url, { ordenPagoID, emails });

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("EnviarOpPorEmail", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * autorizar OP1 - 1er nivel
 * POST /api/Pagos2/AutorizaOP1
 * body: { ordenPagoID: number }
 */
export const startAutorizaOPv2 = (ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/AutorizaOP1`;
    const result = await post(url, { ordenPagoID });

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("AutorizaOP1", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * autorizar OP - 2do nivel
 * POST /api/Pagos2/AutorizaOP2
 * body: { ordenPagoID: number }
 */
export const startAutorizaOP2v2 = (ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/AutorizaOP2`;
    const result = await post(url, { ordenPagoID });

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("AutorizaOP2", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * autorizar Contención - 3er nivel (antes OP3)
 * POST /api/Pagos2/AutorizaContencion
 * body: { ordenPagoID: number }
 */
export const startAutorizaOP3v2 = (ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/AutorizaContencion`;
    const result = await post(url, { ordenPagoID });

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("AutorizaContencion", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * avanzar Pago Directo OP - tipoOP === 2
 * POST /api/Pagos2/AvanzarPagoDirectoOP
 * body: { ordenPagoID: number }
 */
export const startAvanzarPagoDirectoOP = (ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/AvanzarPagoDirectoOP`;
    const result = await post(url, { ordenPagoID });

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("AvanzarPagoDirectoOP", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * validar o Rechazar Documentos de Factura
 * POST /api/Pagos2/ValidarDocumentos
 * body: { ordenPagoID: number, esValido: boolean, motivoRechazo: string }
 */
export const startValidarDocumentos = (ordenPagoID, esValido, motivoRechazo = "") => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/ValidarDocumentos`;
    const body = {
      ordenPagoID,
      esValido,
      motivoRechazo: esValido ? "" : motivoRechazo
    };
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("ValidarDocumentos", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * obtener órdenes de pago para validar factura
 * POST /api/Pagos2/GetOpPorFiltro
 * body: { tipo: number }
 * Tipos: 1=sinFechaAutorizacionContencion, 2=sinFechaAutorizacionPago,
 *        3=sinFechaAutorizacionPago2, 4=sinFechaSolicitudFactura,
 *        5=sinFechaCargaFactura, 7=sinFechaPagado, 8=sinFechaCargaComplementoPago
 */
export const startGetOrdenesValidarFactura = (tipo = 4) => {
  return async (dispatch) => {
    dispatch(setLoadingPagos2(true));

    try {
      const url = `${URL_BASE_PAGOS2}/GetOpPorFiltro`;
      const body = { tipo };

      const result = await post(url, body);

      if (result.code === 0) {
        dispatch(storeOrdenesPagoValidarFactura(result.data));
        return { success: true, data: result.data };
      } else {
        dispatch(
          notification(composeErrorNotification("GetOpPorFiltro"))
        );
        return { success: false, error: result.error };
      }
    } finally {
      dispatch(setLoadingPagos2(false));
    }
  };
};

const storeOrdenesPagoValidarFactura = (payload) => ({
  type: types.storeOrdenesPagoValidarFactura,
  payload,
});

/**
 * action para setear loading de pagos2
 */
export const setLoadingPagos2 = (payload) => ({
  type: types.setLoadingPagos2,
  payload,
});

/**
 * action para guardar filtros de pagos2 (estatus, fechas, scroll)
 */
export const setPagos2Filters = (payload) => ({
  type: types.setPagos2Filters,
  payload,
});

/**
 * obtener lista de asistencias elegibles para agregar a una orden de pago
 * GET /api/OrdenPago/GetListaAsistenciasElegibles/{proveedorID}/{ordenPagoID}
 */
export const startGetListaAsistenciasElegibles = (proveedorID, ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ORDENESPAGO}/GetListaAsistenciasElegibles/${proveedorID}/${ordenPagoID}`;
    const result = await get(url);

    if (result.code === 0) {
      dispatch(storeListaAsistenciasElegibles(result.data));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("GetListaAsistenciasElegibles", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * agregar item a orden de pago
 * POST /api/OrdenPago/AddOrdenPagoRow
 */
export const startAddOrdenPagoRow = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ORDENESPAGO}/AddOrdenPagoRow`;
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("AddOrdenPagoRow", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * eliminar item de orden de pago
 * GET /api/OrdenPago/DeleteOrdenPagoRow/{ordenPagoItemID}/{usuarioID}
 */
export const startDeleteOrdenPagoRow = (ordenPagoItemID, usuarioID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ORDENESPAGO}/DeleteOrdenPagoRow/${ordenPagoItemID}/${usuarioID}`;
    const result = await get(url);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification("Registro removido")));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("DeleteOrdenPagoRow", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * marcar factura como pagada
 * POST /api/pagos2/setoppagado
 * body: { ordenPagoID: number }
 */
export const startUpdateEstadoPago = (ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/setOpPagado`;
    const body = { ordenPagoID };
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("setoppagado", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * crear orden de pago v2
 * POST /api/Pagos2/CrearOrdenPago
 * body: { proveedorID: string, campaniaID: number, asistencias: string[] }
 */
export const startPostCrearOrdenPagoV2 = (body) => {
  return async (dispatch) => {
    dispatch(setCreandoOrdenPago(true));
    try {
      const url = `${URL_BASE_PAGOS2}/CrearOrdenPago`;
      const result = await post(url, body);

      if (result.code === 0) {
        dispatch(notification(composeSuccessNotification("Datos guardados")));
        if (Array.isArray(result.data) && result.data.length > 0) {
          return result.data[0].ordenPagoID;
        }
        return null;
      } else {
        dispatch(
          notification(
            composeErrorNotification(
              "Error de conexion - CrearOrdenPago",
              `${result.error}`
            )
          )
        );
      }
    } finally {
      dispatch(setCreandoOrdenPago(false));
    }
  };
};

const setCreandoOrdenPago = (state) => ({
  type: types.setCreandoOrdenPago,
  payload: state,
});

/**
 * regresar al paso anterior en el flujo de la orden
 * GET /api/Pagos2/RegresoFlujoOp/{ordenPagoID}
 */
export const startRegresoFlujoOp = (ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/RegresoFlujoOp/${ordenPagoID}`;
    const result = await get(url);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data || "Estatus actualizado correctamente")));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("RegresoFlujoOp", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * descargar CSF
 * GET /api/proveedores/GetDocumentoPago/{proveedorID}/ConstanciaSituacionUri
 */
export const startDownloadCSF = (proveedorID) => {
  return async (dispatch, getState) => {
    const url = `${URL_BASE_PROVEEDORES}/GetDocumentoPago/${proveedorID}/ConstanciaSituacionUri`;

    const { constanciaSituacionUri_Azure, constanciaSituacionUri } = getState().ordenesPagoReducer.ordenPago;
    const uri = constanciaSituacionUri_Azure || constanciaSituacionUri;
    const fileExt = uri.split('.').pop();

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `CSF_${proveedorID}.${fileExt}`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);

        dispatch(notification(composeSuccessNotification("CSF descargado correctamente")));
        return { success: true };
      } else {
        dispatch(notification(composeErrorNotification("Error al descargar CSF")));
        return { success: false };
      }
    } catch (error) {
      dispatch(notification(composeErrorNotification("Error al descargar CSF", error.message)));
      return { success: false, error };
    }
  };
};

/**
 * descargar Carátula de Estado de Cuenta
 * GET /api/proveedores/GetDocumentoPago/{proveedorID}/CaratulaEdoCtaUri
 */
export const startDownloadCaratula = (proveedorID) => {
  return async (dispatch, getState) => {
    const url = `${URL_BASE_PROVEEDORES}/GetDocumentoPago/${proveedorID}/CaratulaEdoCtaUri`;

    const { caratulaEdoCtaUri_Azure, caratulaEdoCtaUri } = getState().ordenesPagoReducer.ordenPago;
    const uri = caratulaEdoCtaUri_Azure || caratulaEdoCtaUri;
    const fileExt = uri.split('.').pop();

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `Caratula_${proveedorID}.${fileExt}`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);

        dispatch(notification(composeSuccessNotification("Carátula descargada correctamente")));
        return { success: true };
      } else {
        dispatch(notification(composeErrorNotification("Error al descargar Carátula")));
        return { success: false };
      }
    } catch (error) {
      dispatch(notification(composeErrorNotification("Error al descargar Carátula", error.message)));
      return { success: false, error };
    }
  };
};

/**
 * cargar comprobante de pago XLSX
 * POST /api/OrdenPago/CargaComprobantePagoXLSX
 * body: FormData con file, usuarioId, ordenPagoID
 */
export const startCargaComprobantePagoXLSX = (formData) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ORDENESPAGO}/CargaComprobantePagoXLSX`;

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: formData
      });

      const result = await response.json();

      if (result.code === 0) {
        dispatch(notification(composeSuccessNotification(result.data || "Comprobante cargado correctamente")));
        return { success: true, data: result.data };
      } else {
        dispatch(
          notification(
            composeErrorNotification("CargaComprobantePagoXLSX", `${result.error}`)
          )
        );
        return { success: false, error: result.error };
      }
    } catch (error) {
      dispatch(notification(composeErrorNotification("Error al cargar comprobante", error.message)));
      return { success: false, error };
    }
  };
};

/**
 * cargar comprobante de pago PDF
 * POST /api/OrdenPago/PostDocumento
 * body: FormData con file, filename, mimetype, ordenPagoID, tipo (1=pago), usuarioID
 */
export const startCargaComprobantePagoPDF = (formData) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ORDENESPAGO}/PostDocumento`;

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: formData
      });

      if (!response.ok) {
        const errorText = await response.text();
        dispatch(notification(composeErrorNotification("PostDocumento", errorText)));
        return { success: false, error: errorText };
      }

      const contentType = response.headers.get("content-type");
      let result;

      if (contentType && contentType.includes("application/json")) {
        result = await response.json();
        const message = result.data || result.message || "Comprobante PDF cargado correctamente";
        dispatch(notification(composeSuccessNotification(message)));
        return { success: true, data: result.data };
      } else {
        const textResult = await response.text();
        dispatch(notification(composeSuccessNotification(textResult || "Comprobante PDF cargado correctamente")));
        return { success: true, data: textResult };
      }
    } catch (error) {
      dispatch(notification(composeErrorNotification("Error al cargar comprobante PDF", error.message)));
      return { success: false, error };
    }
  };
};

/**
 * descargar OP v2
 * GET /api/Pagos2/DownloadOP/{ordenPagoID}
 */
export const startDownloadOPv2 = (ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/DownloadOP/${ordenPagoID}`;
    const nombreFinal = `OP_${ordenPagoID}.pdf`;
    const result = await getFile(url, nombreFinal);

    if (result.code === -1) {
      dispatch(
        notification(
          composeErrorNotification("Error de conexion - DownloadOP")
        )
      );
      return { success: false, error: result.error };
    }

    return { success: true, data: result.data };
  };
};

/**
 * obtener detalle de orden de pago V2
 * GET /api/Pagos2/OrdenPago/{ordenPagoID}
 */
export const startGetOrdenPagoV2 = (ordenPagoID) => {
  return async (dispatch) => {
    await dispatch(storeOrdenPagoItems([]));
    await dispatch(storeOrdenPago({}));
    const url = `${URL_BASE_PAGOS2}/OrdenPago/${ordenPagoID}`;
    const result = await get(url);
    if (result.code === 0) {
      dispatch(storeOrdenPago(result.data));
      await dispatch(startOrdenPagoItemsV2(ordenPagoID));
      dispatch(
        startGetListaAsistenciasElegibles(result.data.proveedorID, ordenPagoID)
      );
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("Error de conexion - Get OrdenPago")
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * actualizar item de orden de pago con recarga desde Pagos2
 * POST /api/OrdenPago/UpdateOrdenPagoRow
 * Luego recarga desde /api/Pagos2/OrdenPago/{id}
 */
export const startUpdateOrdenPagoRowAndReload = (body, ordenPagoID) => {
  return async (dispatch, getState) => {
    const { usuarioID } = getState().userReducer.user;
    const url = `${URL_BASE_ORDENESPAGO}/UpdateOrdenPagoRow`;
    const result = await post(url, { ...body, usuarioID });

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      await dispatch(startGetOrdenPagoV2(ordenPagoID));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("UpdateOrdenpagoRow", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * agregar item a orden de pago con recarga desde Pagos2
 * POST /api/OrdenPago/AddOrdenPagoRow
 * Luego recarga desde /api/Pagos2/OrdenPago/{id}
 */
export const startAddOrdenPagoRowAndReload = (body) => {
  return async (dispatch, getState) => {
    const { usuarioID } = getState().userReducer.user;
    const url = `${URL_BASE_ORDENESPAGO}/AddOrdenPagoRow`;

    const result = await post(url, { ...body, usuarioID });

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      await dispatch(startGetOrdenPagoV2(body.ordenPagoID));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("AddOrdenPagoRow", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * eliminar item de orden de pago con recarga desde Pagos2
 * GET /api/OrdenPago/DeleteOrdenPagoRow/{ordenPagoItemID}/{usuarioID}
 * Luego recarga desde /api/Pagos2/OrdenPago/{id}
 */
export const startDeleteOrdenPagoRowAndReload = (ordenPagoItemID, ordenPagoID) => {
  return async (dispatch, getState) => {
    const { usuarioID } = getState().userReducer.user;
    const url = `${URL_BASE_ORDENESPAGO}/DeleteOrdenPagoRow/${ordenPagoItemID}/${usuarioID}`;
    const result = await get(url);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification("Registro removido")));
      await dispatch(startGetOrdenPagoV2(ordenPagoID));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - DeleteOrdenpagoRow",
            `${result.error}`
          )
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * obtener items de orden de pago V2
 * GET /api/OrdenPago/OrdenPagoItems/{ordenPagoID}
 */
export const startOrdenPagoItemsV2 = (ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_ORDENESPAGO}/OrdenPagoItems/${ordenPagoID}`;
    const result = await get(url);

    if (result.code === 0) {
      dispatch(storeOrdenPagoItems(result.data));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("Error de conexion - Get OrdenPagoItems")
        )
      );
      return { success: false, error: result.error };
    }
  };
};

const storeOrdenPago = (payload) => ({
  type: types.storeOrdenPago,
  payload,
});

const storeOrdenPagoItems = (payload) => ({
  type: types.storeOrdenPagoItems,
  payload,
});

/**
 * agregar historial a orden de pago V2
 * POST /api/Pagos2/AddHistorialOrdenPago
 * body: { ordenPagoID: number, usuarioID: number, comentario: string }
 */
export const startAddHistorialOrdenPagoV2 = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/AddHistorialOrdenPago`;
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification("Comentario agregado")));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("AddHistorialOrdenPago", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * descargar XLS de items de orden de pago V2
 * GET /api/Pagos2/GetOrdenPagoItemsXLS/{ordenPagoID}
 */
export const startGetOrdenPagoItemsXLSV2 = (ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/GetOrdenPagoItemsXLS/${ordenPagoID}`;
    const result = await getFile(url, `OrdenPago_${ordenPagoID}.xls`);

    if (result.code === -1) {
      dispatch(
        notification(
          composeErrorNotification("GetOrdenPagoItemsXLS", `${result.error}`)
        )
      );
    }
  };
};

/**
 * descargar documento de orden de pago V2
 * GET /api/Pagos2/DownloadDocumentoOP/{ordenPagoID}/{tipo}
 * tipo: 0=factura, 1=pago, 2=complemento
 */
export const startDownloadDocumentoOPV2 = (ordenPagoID, tipo) => {
  return async (dispatch) => {
    try {
      const url = `${URL_BASE_ORDENESPAGO}/DownloadDocumentoOP/${ordenPagoID}/${tipo}`;
      const tipoNombre = tipo === 0 ? "Factura" : tipo === 1 ? "Pago" : "Complemento";
      const result = await getFile(url, `${tipoNombre}_${ordenPagoID}.pdf`);

      if (result.code === -1) {
        dispatch(
          notification(
            composeErrorNotification("DownloadDocumentoOP", `${result.error}`)
          )
        );
        return { success: false, error: result.error };
      } else {
        return { success: true };
      }
    } catch (error) {
      dispatch(
        notification(
          composeErrorNotification("DownloadDocumentoOP", error.message || "Error al descargar documento")
        )
      );
      return { success: false, error: error.message };
    }
  };
};

/**
 * marcar estatus de orden de pago V2
 * POST /api/Pagos2/MarcarEstatus
 * body: { ordenPagoID: number, estatusOrdenPagoID: number }
 */
export const startMarcarEstatusV2 = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/MarcarEstatus`;
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("MarcarEstatus", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * actualizar item de orden de pago V2
 * POST /api/Pagos2/UpdateOrdenPagoRow
 * body: { ordenPagoItemID, ordenPagoID, asistenciaID, claveSAT, monto, iva, ivaRetenido, isrRetenido }
 */
export const startUpdateOrdenPagoRowV2 = (body, ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/UpdateOrdenPagoRow`;
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification("Datos actualizados")));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("UpdateOrdenPagoRow", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * agregar item a orden de pago V2
 * POST /api/Pagos2/AddOrdenPagoRow
 * body: { asistenciaID: number, ordenPagoID: number, usuarioID: number }
 */
export const startAddOrdenPagoRowV2 = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/AddOrdenPagoRow`;
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("AddOrdenPagoRow", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * eliminar item de orden de pago V2
 * GET /api/Pagos2/DeleteOrdenPagoRow/{ordenPagoItemID}/{usuarioID}
 */
export const startDeleteOrdenPagoRowV2 = (ordenPagoItemID, usuarioID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/DeleteOrdenPagoRow/${ordenPagoItemID}/${usuarioID}`;
    const result = await get(url);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification("Registro removido")));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("DeleteOrdenPagoRow", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * obtener lista de asistencias elegibles V2
 * GET /api/Pagos2/GetListaAsistenciasElegibles/{proveedorID}/{ordenPagoID}
 */
export const startGetListaAsistenciasElegiblesV2 = (proveedorID, ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/GetListaAsistenciasElegibles/${proveedorID}/${ordenPagoID}`;
    const result = await get(url);

    if (result.code === 0) {
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("GetListaAsistenciasElegibles", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * buscar orden de pago por ID V2
 * GET /api/Pagos2/OrdenPago/{ordenPagoID}
 * Verifica que la orden exista
 */
export const startBuscaOrdenPagoIDV2 = (ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/OrdenPago/${ordenPagoID}`;
    const result = await get(url);
    if (result.code === 0) {
      return { success: true, data: result.data };
    } else {
      dispatch(notification(composeErrorNotification("OrdenPago no encontrada", result.error)));
      return { success: false, error: result.error };
    }
  };
};

/**
 * buscar asistencia por ID y obtener la orden de pago V2
 * GET /api/OrdenPago/BuscaAsistenciaID/{asistenciaID} (legacy)
 * Luego verifica la orden en Pagos2
 */
export const startBuscaAsistenciaIDV2 = (asistenciaID) => {
  return async (dispatch) => {
    const urlAsistencia = `${URL_BASE_ORDENESPAGO_BUSCAR}/BuscaAsistenciaID/${asistenciaID}`;
    const resultAsistencia = await get(urlAsistencia);

    if (resultAsistencia.code === 0) {
      const ordenPagoID = resultAsistencia.data;

      const urlOrdenPago = `${URL_BASE_PAGOS2}/OrdenPago/${ordenPagoID}`;
      const resultOrdenPago = await get(urlOrdenPago);

      if (resultOrdenPago.code === 0) {
        return { success: true, data: resultOrdenPago.data, ordenPagoID };
      } else {
        dispatch(notification(composeErrorNotification("OrdenPago no encontrada en Pagos2", resultOrdenPago.error)));
        return { success: false, error: resultOrdenPago.error };
      }
    } else {
      dispatch(notification(composeErrorNotification("Asistencia no encontrada", resultAsistencia.error)));
      return { success: false, error: resultAsistencia.error };
    }
  };
};

/**
 * descargar XLS de órdenes de pago por filtro
 * POST /api/Pagos2/GetXlsPorFiltro
 */
export const startDescargarOpXls = (tipo) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/GetXlsPorFiltro`;
    const nombreFinal = `OrdenesPago_${new Date().toISOString().split('T')[0]}.xls`;
    const result = await postGetFile(url, nombreFinal, { tipo });

    if (result.code === -1) {
      dispatch(
        notification(
          composeErrorNotification("Error de conexion - GetXlsPorFiltro")
        )
      );
      return { success: false, error: result.error };
    }

    return { success: true, data: result.data };
  };
};

export const startGetXlsSinComplementoPago = (anio) => {
  return async () => {
    const url = `${URL_BASE_PAGOS2}/GetXlsSinComplementoPago`;
    const result = await postGetFile(url, `ComplementosPago_${anio}.xls`, { anio });

    if (result.code === -1) {
      return { success: false, error: result.error };
    }

    return { success: true, data: result.data };
  };
};

const storeListaAsistenciasElegibles = (lista) => ({
  type: types.storeListaAsistenciasElegibles,
  payload: lista,
});

/**
 * cargar documento de autorización concesionados
 * POST /api/Pagos2/DocumentosConcesionados
 * body: FormData con File, OrdenPagoID
 */
export const startCargarDocumentoConcesionados = (formData) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/DocumentosConcesionados`;
    const result = await postFile(url, formData);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data || "Documento guardado")));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("DocumentosConcesionados", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * descargar documento de autorización concesionados
 * GET /api/Pagos2/GetDocumentotAutorizacionConcesionados/{ordenPagoID}
 */
export const startDescargarDocumentoConcesionados = (ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/GetDocumentotAutorizacionConcesionados/${ordenPagoID}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `Autorizacion_Concesionado_${ordenPagoID}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);

        dispatch(notification(composeSuccessNotification("Documento descargado correctamente")));
        return { success: true };
      } else {
        dispatch(notification(composeErrorNotification("Error al descargar documento")));
        return { success: false };
      }
    } catch (error) {
      dispatch(notification(composeErrorNotification("Error al descargar documento", error.message)));
      return { success: false, error };
    }
  };
};

/**
 * crear orden de pago concesionados
 * POST /api/Pagos2/Concesionados
 * body: { asistencias: number[] }
 */
export const startCrearOrdenPagoConcesionados = (asistencias) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/Concesionados`;
    const body = { asistencias };
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data || "Orden de pago concesionada creada")));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("Error de conexión - Concesionados", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * guardar Analítica Odoo en la orden de pago
 * POST /api/Pagos2/SetAnaliticaOdoo
 * body: { ordenPagoID, analiticaOdoo }
 */
export const startSetAnaliticaOdoo = (ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/SetAnaliticaOdoo`;
    const result = await post(url, { ordenPagoID: Number(ordenPagoID) });

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification("Analítica Odoo actualizada")));
      await dispatch(startGetOrdenPagoV2(ordenPagoID));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("Error al actualizar Analítica Odoo", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * eliminar orden de pago
 * DELETE /api/Pagos2/EliminarOP/{ordenPagoID}
 */
export const startEliminarOP = (ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/EliminarOP/${ordenPagoID}`;
    const result = await dele(url);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data || "Orden de pago eliminada correctamente")));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("Error al eliminar orden de pago", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * archivar o desarchivar orden de pago
 * POST /api/Pagos2/SetOpArchivado
 * body: { ordenPagoID: number, archivado: boolean }
 */
export const startSetOpArchivado = (ordenPagoID, archivado) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/SetOpArchivado`;
    const body = { ordenPagoID, archivado };
    const result = await post(url, body);

    if (result.code === 0) {
      const mensaje = archivado ? "Orden de pago archivada correctamente" : "Orden de pago desarchivada correctamente";
      dispatch(notification(composeSuccessNotification(result.data || mensaje)));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("Error al archivar orden de pago", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * carga masiva de pagos
 * POST /api/Pagos2/CargaPagoMasivo
 * body: { fecha: "YYYY-MM-DD", ordenesPagoID: number[] }
 */
export const startCargaPagoMasivo = (body) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/CargaPagoMasivo`;
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data || "Carga masiva procesada correctamente")));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("Error en carga masiva", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * ajustar cliente en orden de pago
 * GET /api/OpActions/SetClienteEnOp/{ordenPagoID}
 */
export const startSetClienteEnOp = (ordenPagoID) => {
  return async (dispatch) => {
    const url = `${URL_BASE}/api/OpActions/SetClienteEnOp/${ordenPagoID}`;
    const result = await get(url);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("Error al ajustar cliente", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * admin status override
 * POST /api/Pagos2/CambioEstatusOP
 * body: { ordenPagoID: number, estatusOrdenPagoID: number, brincar?: number }
 */
export const startAdminStatusOverride = (ordenPagoID, estatusOrdenPagoID, brincar) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/CambioEstatusOP`;
    const body = { ordenPagoID, estatusOrdenPagoID, brincar };
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data || "Estatus actualizado correctamente")));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("Error al cambiar estatus", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};

/**
 * POST /api/Pagos2/RechazarOP
 * body: { ordenPagoID: number, motivoRechazo: string }
 */

export const startRechazarOp = (ordenPagoID, motivoRechazo) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/RechazarOP`
    const body = { ordenPagoID, motivoRechazo }
    const result = await post(url, body);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data)))
      return { success: true, data: result.data }
    } else {
      dispatch(notification(composeErrorNotification(result.error)))
      return { success: false, error: result.error }
    }
  }
};

/**
 * Crear orden de pago Concesionados con documentos
 * POST /api/Pagos2/Concesionados
 * body: FormData con:
 *   - FacturaPDF (binary)
 *   - FacturaXML (binary)
 *   - VerificacionFactura (binary)
 *   - UsuarioID (string)
 *   - Asistencias (string: "ASIST_001,ASIST_002")
 */
export const startCrearConcesionadosConDocumentos = (formData) => {
  return async (dispatch) => {
    const url = `${URL_BASE_PAGOS2}/Concesionados`;
    const result = await postFile(url, formData);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification(result.data || "Orden concesionada creada")));
      return { success: true, data: result.data };
    } else {
      dispatch(
        notification(
          composeErrorNotification("Error de conexión - Concesionados", `${result.error}`)
        )
      );
      return { success: false, error: result.error };
    }
  };
};
